import React, { useEffect, useState, useRef, Fragment } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import { FormControl, InputLabel, MenuItem, Select, TextField, Tooltip } from '@material-ui/core';
import moment from 'moment';

import styles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';
import stylesAlert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { Assignment, Close, DoneAll, YoutubeSearchedFor, Pages, Create } from '@material-ui/icons';
import SweetAlert from 'react-bootstrap-sweetalert';

import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import { wsFindBy, wsCreate } from 'services/WService';

import DetailsNC from './DetailsNCSharedFile';
import NCNormal from './ContainerHeader/NCNormal';
import NCLeftOvers from './ContainerHeader/NCLeftOvers';
import { wsPost, wsGetAll } from 'services/WService';
import { useModal } from 'hooks/useModal';
import NCModal from './NCModal';
import DetailsNCConcepts from './DetailsNCConcepts';

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stylesAlert,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold',
  },
  totals: {
    '& td': {
      fontWeight: '500',
    },
  },
}));

const getValuesInput = (ref) => {
  let dataForm = {};
  for (let input of ref.current.querySelectorAll('[name]')) {
    dataForm[input.name] = input.value;
  }
  return dataForm;
};

export default WithApp(function NCredito(props) {
  const classes = useStyles();
  const { type, title, permission } = props;

  const forFilterNC = useRef(null);
  const formNCLHeader = useRef(null);
  const formNCNHeader = useRef(null);
  const [processing, setProcessing] = useState(false);

  const [notify, showNotify] = useToasty();
  const [document, setDocumentNC] = useState({});
  const [DocType, setDocType] = useState('I');
  const [concepts, setConcepts] = useState([]);
  // data por defecto,
  const [dataHeader, setDataHeader] = useState({});
  const [detailsNC, setDetailsNC] = useState([]);
  const [docTypes, setDocTypes] = useState([]);
  /* const [importe, setImporte] = useState(0); */
  const [responseData, setResponseData] = useState(undefined);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [itemDeletes, setItemDeletes] = useState([]);
  const [model, setOpen] = useModal();

  const handleChange = (e) => {
    setDataHeader({ ...dataHeader, [e.target.name]: e.target.value });
  };

  const handleRemove = (code) => {
    setItemDeletes([...itemDeletes, code]);
  };

  const handleAdd = (code) => {
    let cloneCodes = [...itemDeletes];
    cloneCodes.splice(
      cloneCodes.findIndex((x) => x === code),
      1,
    );
    setItemDeletes([...cloneCodes]);
  };

  const calcTotalNCN = () => {
    const res = detailsNC.filter(({ LineNum }) => itemDeletes.includes(LineNum));
    const total = res.reduce((a, b) => a + parseFloat(b.GTotal), 0);
    setDocumentNC({ ...document, amount_Exclude: total });
  };

  useEffect(() => {
    if (type === 'NCN' && document.U_SYP_MDCD) calcTotalNCN();
  }, [itemDeletes]);

  const changeAutocomplete = (field, value, dataForce = {}) => {
    if (field === 'base_zone_id') {
      delete dataHeader.base_seller_id;
      delete dataHeader.base_business_partner_id;
    }
    setDataHeader({
      ...dataHeader,
      [field]: value,
      ...dataForce
    });
  };

  async function getDocumentNC() {
    let response = await wsFindBy('sap/OINV/find', { ...getValuesInput(forFilterNC) });
    if (response.success) {
      setDocumentNC({
        ...response.data.saleOrder,
        ...response.data,
        amount_Exclude: 0,
        gross_amount: response.data?.DocTotal,
      });

      if (type === 'NCN') {
        let details = response.data.details.map((item) => {
          return { ...item, unit_price: item.PriceAfVAT };
        });
        setDetailsNC(details);
      }
      if (type === 'NCL') {
        setDataHeader({
          U_SYP_MDTD: response.data.U_SYP_MDTD,
          U_SYP_MDSD: response.data.U_SYP_MDSD,
          U_SYP_MDCD: response.data.U_SYP_MDCD,
          base_zone_id: response.data.saleOrder?.base_zone_id,
          base_business_partner_id: response.data.saleOrder?.base_business_partner_id,
          CardName: response.data.saleOrder?.CardName,
          base_address_id: response.data.saleOrder?.base_address_id,
          Address2: response.data.saleOrder?.Address2
        });
      }

      /* delete response.data.details; */
    } else {
      setDetailsNC([]);
      setDocumentNC({});
      setDataHeader({});
      showNotify(response.message, 'error');
    }
  }

  async function listDocTypes() {
    let response = await wsGetAll('base/sunat-document-type/prt');
    if (response.success) setDocTypes(response.data);
  }

  //#region --- funcion para mostrar alert de confirmacion al aprobar o anular
  const [alertAprobed, setAlertAprobed] = useState(null);
  function confirmChange(status) {
    setAlertAprobed(
      <SweetAlert
        warning={status}
        input={!status}
        style={{ display: 'block', marginTop: '-100px' }}
        title={`¿Esta seguro de ${status ? 'Aprobar' : 'Anular'} ?`}
        onConfirm={(e) => {
          if (status) {
            approveOrCancel(status);
          } else {
            approveOrCancel(status, { ObservacionError: e });
          }
          setAlertAprobed(null);
        }}
        onCancel={() => setAlertAprobed(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {status ? ' ¡Esta acción tiene consecuencias!' : 'Ingrese el motivo por favor :)'}
      </SweetAlert>,
    );
  }
  //#endregion

  async function saveData(dataDetails) {
    let details = dataDetails.map((item) => {
      const data = {
        ItemCode: item.ItemCode,
        digitate_units: item.Quantity,
        digitate_amount: 0,
        digitate_package_price: 0,
        digitate_packages: 0,
        digitate_units_price: 0,
        total_units: 0,
        units_package: 0,
      };
      if (type === 'NCN') data.LineNum = item.LineNum;
      return data;
    });

    if (type === 'NCN') {
      const items = details.filter((item) => itemDeletes.indexOf(item.LineNum) == -1);
      details = items;
    }

    if (details.length < 1) {
      showNotify('Ingrese almenos un detalle', 'info');
      return;
    }

    let header;

    if (type == 'NCN') {
      header = {
        U_SYP_MDCD: document.U_SYP_MDCD,
        U_SYP_MDSD: document.U_SYP_MDSD,
        U_SYP_MDTD: document.U_SYP_MDTD,
        base_address_id: document.base_address_id,
        base_seller_id: document.base_seller_id,
        base_business_partner_id: document.base_business_partner_id,
        ...getValuesInput(formNCNHeader),
      };
    } else {
      header = { ...getValuesInput(formNCLHeader), ...dataHeader };
    }

    const data = {
      order: {
        DocType,
        ...header,
        digitate_gross_amount: 0,
        digitate_total_amount: 0,
        order_type: type === 'NCN' ? 'W' : type === 'NCL' ? 'O' : '',
      },
      details,
    };

    setProcessing(true);
    /* return; */
    let response = await wsCreate('sale/credit-note', data);
    if (response.success) {
      showNotify(response.message);
      setResponseData(response.data);
      setIsUpdate(false);
      setIsSaving(true);
    } else {
      showNotify(response.message, 'error');
      setResponseData(undefined);
    }
    setProcessing(false);
  }

  async function processConcept() {
    let conceptsData = concepts.map((concept) => {
      const data = {
        Dscription: concept.Dscription,
        Price: concept.Price,
        DiscPrcnt: concept.DiscPrcnt,
        VatGroup: concept.VatGroup,
        AcctCode: concept.AcctCode,
      };
      // if (type === 'NCN') data.LineNum = item.LineNum;
      return data;
    });

    if (concepts.length < 1) {
      showNotify('Ingrese almenos un detalle', 'info');
      return;
    }

    let header = {
      U_SYP_MDCD: document.U_SYP_MDCD,
      U_SYP_MDSD: document.U_SYP_MDSD,
      U_SYP_MDTD: document.U_SYP_MDTD,
      base_address_id: document.base_address_id,
      base_seller_id: document.base_seller_id,
      base_business_partner_id: document.base_business_partner_id,
      ...getValuesInput(formNCNHeader),
    };

    const data = {
      order: {
        DocType,
        ...header,
        digitate_gross_amount: 0,
        digitate_total_amount: 0,
        order_type: type === 'NCN' ? 'W' : type === 'NCL' ? 'O' : '',
      },
      concepts: conceptsData,
    };

    setProcessing(true);
    let response = await wsCreate('sale/credit-note', data);
    if (response.success) {
      showNotify(response.message);
      setResponseData(response.data);
      setIsUpdate(false);
      setIsSaving(true);
    } else {
      showNotify(response.message, 'error');
      setResponseData(undefined);
    }
    setProcessing(false);
  }

  const clearData = () => {
    setDocumentNC({});
    setDataHeader({});
    setDetailsNC([]);
    /* setImporte(0); */
    setResponseData(undefined);
    setIsUpdate(false);
    setIsSaving(false);
  };

  async function approveOrCancel(status, data = undefined, updating) {
    let response = await wsPost(
      `sale/credit-note/${responseData.order.id}/${status ? 'approve' : 'annular'}`,
      data === undefined ? '' : data,
    );
    if (response.success) {
      showNotify(response.message);
      if (status || (!updating && !status)) {
        clearData();
      }
    } else {
      showNotify(response.message, 'error');
      setIsUpdate(false);
    }
  }

  useEffect(() => {
    listDocTypes();
  }, []);

  return (
    <Fragment>
      <NCModal model={model} setOpen={setOpen} document={document} />
      <Toasty action={notify} />
      {alertAprobed}
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>{`Datos generales ${title}`}</h4>
        </CardHeader>
        <CardBody>
          <form
            ref={forFilterNC}
            onSubmit={(e) => {
              e.preventDefault();
              getDocumentNC();
            }}
          >
            <h5 style={{ margin: 0, fontWeight: 400 }}>Documento de referencia</h5>
            <GridContainer>
              <GridItem xs={12} md={4} lg={2}>
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>Tipo documento</InputLabel>
                  <Select defaultValue="" inputProps={{ name: 'U_SYP_MDTD' }} disabled={isSaving}>
                    {docTypes.map((item) => (
                      <MenuItem key={item.id} value={item.code}>
                        {item.description}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Serie"
                  fullWidth
                  name="U_SYP_MDSD"
                  margin="normal"
                  size="small"
                  required
                  defaultValue=""
                  disabled={isSaving}
                />
              </GridItem>
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Código"
                  fullWidth
                  name="U_SYP_MDCD"
                  margin="normal"
                  size="small"
                  required
                  defaultValue=""
                  disabled={isSaving}
                />
              </GridItem>
              <GridItem xs={12} md={1} lg={1} style={{ display: 'flex', alignItems: 'flex-end' }}>
                <Button
                  justIcon
                  round
                  size="sm"
                  color={props.themeContext.buttonColor}
                  type="submit"
                  disabled={isSaving}
                >
                  <YoutubeSearchedFor />
                </Button>
                <Tooltip title="NC Existentes">
                  <Button
                    justIcon
                    round
                    size="sm"
                    color="success"
                    disabled={!document?.creditNotes?.length > 0}
                    onClick={() => setOpen()}
                  >
                    <Pages />
                  </Button>
                </Tooltip>
              </GridItem>
              {Object.keys(document).length > 0 ? (
                <>
                  <GridItem xs={12} md={4} lg={2}>
                    <TextField
                      label="Fecha Contable"
                      fullWidth
                      margin="normal"
                      size="small"
                      disabled
                      value={moment(document.DocDate).format('DD-MM-YYYY')}
                    />
                  </GridItem>
                  <GridItem xs={12} md={4} lg={2}>
                    <TextField
                      label="Fecha documento"
                      fullWidth
                      margin="normal"
                      size="small"
                      disabled
                      value={moment(document.TaxDate).format('DD-MM-YYYY')}
                    />
                  </GridItem>
                </>
              ) : undefined}
            </GridContainer>
          </form>

          {Object.keys(document).length > 0 && type === 'NCN' ? (
            <form
              id="formNCNHeader"
              ref={formNCNHeader}
              onSubmit={(e) => {
                e.preventDefault();
                saveData(detailsNC);
              }}
            >
              <NCNormal
                document={document}
                isSaving={isSaving}
                DocType={DocType}
                setDocType={setDocType}
              />
            </form>
          ) : Object.keys(dataHeader).length > 0 && type === 'NCL' ? (
            <form
              id="formNCLHeader"
              ref={formNCLHeader}
              onSubmit={(e) => {
                e.preventDefault();
                saveData(detailsNC);
              }}
            >
              <NCLeftOvers
                dataHeader={dataHeader}
                handleChange={handleChange}
                changeAutocomplete={changeAutocomplete}
                showNotify={showNotify}
                type={type}
                formDataHeader={formNCLHeader}
                isSaving={isSaving}
              />
            </form>
          ) : undefined}
        </CardBody>
      </Card>
      {Object.keys(document).length > 0 ? (
        <>
          {DocType === 'I' && (
            <DetailsNC
              typeNC={type}
              dataHeader={dataHeader}
              setDataHeader={setDataHeader}
              detailsNC={detailsNC}
              setDetailsNC={setDetailsNC}
              document={document}
              setDocumentNC={setDocumentNC}
              /* importe={importe} */
              /* setImporte={setImporte} */
              showNotify={showNotify}
              isSaving={isSaving}
              itemDeletes={itemDeletes}
              setItemDeletes={setItemDeletes}
              handleRemove={handleRemove}
              handleAdd={handleAdd}
            />
          )}
          {DocType === 'S' && (
            <DetailsNCConcepts
              concepts={concepts}
              setConcepts={setConcepts}
              isSaving={isSaving}
              showNotify={showNotify}
              document={document}
              dataHeader={dataHeader}
            />
          )}
        </>
      ) : undefined}

      {(DocType === 'I' && detailsNC?.length > 0 && !responseData) || isUpdate ? (
        <Button
          color={props.themeContext.buttonColorSuccess}
          type="submit"
          form={type === 'NCN' ? 'formNCNHeader' : 'formNCLHeader'}
          style={{ float: 'right', marginTop: '15px' }}
          disabled={processing}
        >
          {processing ? 'Guardando...' : 'Guardar'}
        </Button>
      ) : undefined}

      {DocType === 'S' && concepts.length > 0 && !responseData && (
        <Button
          color="success"
          onClick={processConcept}
          style={{ float: 'right', marginTop: '15px' }}
          disabled={processing}
        >
          {processing ? 'Guardando...' : 'Guardar'}
        </Button>
      )}

      {responseData && !isUpdate ? (
        <>
          {responseData.order.state === 'R' ? (
            <Card>
              <CardBody>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                  <span>Pedido retenido</span>
                  <ul>
                    {responseData.order.retention_reasons.split(',').map((reason, index) => {
                      return <li key={index}>{reason}</li>;
                    })}
                  </ul>

                  <Button color="warning" style={{ marginRight: '20px' }} onClick={clearData}>
                    <Create /> Ok
                  </Button>
                </div>
              </CardBody>
            </Card>
          ) : (
            <>
              <Button
                color={props.themeContext.buttonColorSuccess}
                onClick={() => {
                  confirmChange(true);
                }}
                style={{ float: 'right', marginTop: '15px', marginLeft: '15px' }}
              >
                <DoneAll /> Aprobar
              </Button>
              <Button
                color={props.themeContext.buttonColorDanger}
                onClick={() => {
                  confirmChange(false);
                }}
                style={{
                  float: 'right',
                  marginTop: '15px',
                }}
              >
                <Close /> Anular
              </Button>
              <Button
                color={props.themeContext.buttonColorWarning}
                onClick={() => {
                  setIsUpdate(true);
                  setIsSaving(false);
                  approveOrCancel(false, undefined, true);
                }}
                style={{ float: 'right', marginTop: '15px', marginRight: '15px' }}
              >
                <DoneAll /> Editar
              </Button>
            </>
          )}
        </>
      ) : undefined}
    </Fragment>
  );
});
